import React, { FC } from 'react';
import Icon from '../../@shared/icon';
import Picture from '../../@shared/picture';
import { TMediaElement } from '../types/productSeriesDetailTestimonial.types';

const MediaElement: FC<TMediaElement> = (props) => {
  const { isMediaShown, useVideo, desktopRendition, mobileRendition, altText, assetRole, showOverlayVideo, thumbnailImgSrc } = props;
  if (isMediaShown || useVideo) {
    return (
      <div className="testimonial__image-wrapper">
        <Picture
          productImageProps={{
            desktopRendition: desktopRendition,
            mobileRendition: mobileRendition,
            ...(assetRole === 'extvideo' && { desktopRendition: { url: thumbnailImgSrc } }),
            imageClassName: 'slide-card__image',
            alt: altText,
            isVideoThumbnail: useVideo,
          }}
        />
        {useVideo && (
          <div onClick={showOverlayVideo} className="testimonial-card__video-play-button">
            <Icon iconName="action-play" size={32} color="white" />
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default MediaElement;
